export const isOlderVersion = ({ incomingChanges, storedState }) =>
	incomingChanges?.version &&
	storedState?.version &&
	new Date(storedState.version) > new Date(incomingChanges.version);

export const isNewerVersion = ({ incomingChanges, storedState }) =>
	!storedState.version ||
	(incomingChanges.version && new Date(storedState.version) < new Date(incomingChanges.version));
